import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { ConnectorVariantModel } from '../../../../models/parts/connectorVariant.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { list } from './mock-variant-grid-data';
import { mockedPicture } from './mock-picture-base64';
import { mockedStepFile } from './mock-step-file-base64';
import { SystemModel } from '../../../../models/dictionaries/system.model';
import { ShowViewerArgs } from '../../../../models/viewer/ShowViewerArgs.model';
import { CorosiveProtectionModel } from '../../../../models/dictionaries/corosive-protection.model';
import { UniversalConnectorModel, ConnectorType } from '../../../../models/parts/universal-connector.model';
import { DesignBaseModel } from '../../../../models/dictionaries/design-base.model';

// declare var $: any;

@Component({
  selector: 'app-bases-managment',
  template: `<div *ngIf="baseData !== undefined">
    <div class="row" style="padding-left: 12px;">
        <b>Base:</b> &nbsp;{{baseData.name}}</div>
    <div class="row" style="margin: 10px;">
        <!-- <button class="gray-button" (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">Open graphical tool</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#editModal">Edit</button>
        <!-- <button class="gray-button" >Drawing/Pictures</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#uploadModal">Upload file</button>
        <button class="gray-button" data-toggle="modal" data-target="#deleteModal">Delete</button>
    </div>
    <div class="row">
        <div class="col-6" style="line-height: 30px; padding-top: 30px;">
            <div class="d-inline">Article no:
            </div>
            <div class="d-inline">{{baseData.articleNumber}}
                <br>
            </div>
            <div class="d-inline">Name:
            </div>
            <div class="d-inline">{{baseData.name}}
                <br>
            </div>
            <div class="d-inline">Description:
            </div>
            <div class="d-inline">{{baseData.description}}
                <br>
            </div>
            <div class="d-inline">System:
            </div>
            <div class="d-inline">{{baseData.system}}
                <br>
            </div>
            <div class="d-inline">Corrosion protection:
            </div>
            <div class="d-inline">{{baseData.corrosionProtection}}
                <br>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div id="regularPictureDiv" [hidden]="!isPngVisible">
                    <div class="row">
                        <img height=150 width=150 [src]="pictureData" id="regularPicture">
                    </div>
                    <div class="row">
                        <label style="font-size:12px">Main picture</label>
                        <button style="font-size:12px;height:23px;margin-left: 3px;" (click)="deletePicture()">x</button>
                    </div>
                </div>
                <div id="stpFileDiv" [hidden]="!isStpVisible">
                    <div class="step-file">STEP FILE</div>
                    <div class="row">
                        <img height=150 width=150 src="https://www.freeviewer.org/img/stp/overview-stp.png" id="stpPicture">
                    </div>
                    <div class="row" style="margin-top: 10px; margin-left: 10px;">
                        <button class="configure-button" style="font-size:12px;height:23px;margin-left: 3px;" (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">
                            Configure
                        </button>
                        <button class="delete-button" style="font-size:12px;height:23px;margin-left: 3px;" (click)="deleteStepFile()">x</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="variants-header">
        <span style="padding-left: 18px; font-weight: bold; align-self: flex-end; padding-bottom: 3px;">Variants:</span>
        <button class="red-button" data-toggle="modal" data-target="#createVariantModal" (click)="prepareVariantCreate()"> Create new variant</button>
        <!-- <hc-button [type]="rectsm" [action]="additional">Additional Flat Button</hc-button> -->
    </div>
    <div *ngIf="variantsList.length > 0" class="regularObjectBorder" id="variantsGrid">
        <div class="row">
            <div class="regularObjectBorder justRightBorder borderGray" *ngFor="let variant of variantsList;let i=index">
                <button [class.highlighted]="variant._id === currentVariantTabId" class="variantBtn" (click)="changeVariantTab(variant._id)">{{variant.name}}</button>
            </div>
        </div>
        <div class="row" style="padding: 18px 6px;">
            <button data-toggle="modal" data-target="#editVariantModal" class="gray-button">Edit</button>
            <button data-toggle="modal" data-target="#duplicateVariantModal" class="gray-button">Duplicate</button>
            <button data-toggle="modal" data-target="#deleteVariantModal" class="gray-button">Delete</button>
            <button class="gray-button">Utilization check</button>
            <button class="gray-button" (click)="openVariantGraphicalTool(variantsList[currentVariantTab]._id)">Launch Graphical Tool</button>
        </div>
        <div id="tabContent" class="regularObjectBorder justTopBorder">
            <div class="row" style="margin-top: 18px;">
                <div class="col-6">
                    <div class="font-weight-bold table-label">Name:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].name}}</div>
                    <div class="extra-padding-top font-weight-bold table-label">Description:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].description}}
                        <br>
                    </div>
                    <div class="extra-padding-top font-weight-bold table-label">Design base:
                        <br>
                    </div>
                    <div>
                        <select class="tableCurrentVariant" [(ngModel)]="choosenDesignBase">
                            <option *ngFor="let designBase of designBasesArray | sortByName" [(value)]="designBase._id">{{designBase.name}}</option>
                        </select>
                        <br>
                    </div>
                </div>
                <div class="col-6">
                    <div class="font-weight-bold table-label">System:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].system}}
                        <br>
                    </div>
                    <div class="extra-padding-top font-weight-bold table-label">Corrosion protection:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">{{variantsList[currentVariantTab].corrosionProtection}}
                        <br>
                    </div>
                    <div class="extra-padding-top font-weight-bold table-label">Files:
                        <br>
                    </div>
                    <div class="regularObjectBorder justBottomBorder tableCurrentVariant">&nbsp;</div>
                </div>

            </div>
            <div class="row">
                <!-- <hc-data-grid style="width:-webkit-fill-available" [select]="false" id="variantsTabGrid" [data]="variantGridData" [headers]="headersVariantGrid"
                    [subheader]="false" [displayedColumns]="displayedColumns">
                </hc-data-grid> -->
                <br>
                <app-variant-verification-grid [DesignBaseId]="choosenDesignBase" [VariantId]="variantsList[currentVariantTab]._id"></app-variant-verification-grid>
            </div>
        </div>
    </div>
    <div class="col-6" *ngIf="variantsList.length == 0">
        <span>No variants available</span>
    </div>
</div>

<!-- Upload Modal -->
<div class="modal" id="uploadModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    Select file:
                    <br/>
                    <input #fileUploadInput type="file" accept=".jpg,.jpeg,.png,.step,.stp">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="upload()">Upload</button>
            </div>

        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Article no:</span>
                                    <input type="number" formControlName="articleNumber" [(ngModel)]="editedBase.articleNumber">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedBase.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedBase.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">System:</span>
                                    <select name="systemSelect" class="selectHeight" [(ngModel)]="editedBase.system" formControlName="system">
                                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Corrosion protection:</span>
                                    <select name="corrProtSelect" class="selectHeight" formControlName="corrosionProtection" [(ngModel)]="editedBase.corrosionProtection">
                                        <option *ngFor="let corrosionProtection of corrosionProtectionsArray | sortByName" [ngValue]="corrosionProtection.name">{{corrosionProtection.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="save()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this base?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="deleteBase()">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- Create Variant Modal -->
<div class="modal" id="createVariantModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="variantFormGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="variantTemplateModel.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="variantTemplateModel.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">System:</span>
                                    <select name="systemSelect" class="selectHeight" [(ngModel)]="variantTemplateModel.system" formControlName="system">
                                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Corrosion protection:</span>
                                    <select name="corrProtSelect" class="selectHeight" formControlName="corrosionProtection" [(ngModel)]="variantTemplateModel.corrosionProtection">
                                        <option *ngFor="let corrosionProtection of corrosionProtectionsArray | sortByName" [ngValue]="corrosionProtection.name">{{corrosionProtection.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="variantFormGroup.invalid" (click)="saveNewVariant()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- Duplicate Variant Modal -->
<div class="modal" id="duplicateVariantModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <div>Duplicate variant</div>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">New variant name:</span>
                    <input type="text" [(ngModel)]="variantTemplateModel.name">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="variantTemplateModel.name.length<3"
                    (click)="duplicateVariant()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Variant Modal -->
<div class="modal" id="deleteVariantModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <div>Delete variant</div>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span>Are you sure, you want to delete this variant?</span>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="deleteVariant()">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Variant Modal -->
<div class="modal" id="editVariantModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="editedVariant.name">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="editedVariant.description">
                </div>
                <div class="display-flex">
                    <span class="modal-label">System:</span>
                    <select name="systemSelect" [(ngModel)]="editedVariant.system" class="selectHeight">
                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                    </select>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Corrosion protection:</span>
                    <select name="corrProtSelect" [(ngModel)]="editedVariant.corrosionProtection" class="selectHeight">
                        <option *ngFor="let corrosionProtection of corrosionProtectionsArray | sortByName" [ngValue]="corrosionProtection.name">{{corrosionProtection.name}}</option>
                    </select>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="editedVariant.name.length<3 || editedVariant.corrosionProtection.length<1 || editedVariant.system.length<1"
                    (click)="updateVariant()">Save</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}`]
})
export class BasesManagmentComponent implements OnInit {
  @ViewChild('fileUploadInput') fileInput;
  @Output() onShowViewer: EventEmitter<ShowViewerArgs> = new EventEmitter();

  public baseData: any;
  public editedBase = new UniversalConnectorModel(ConnectorType.Base);
  public editedVariant = new ConnectorVariantModel();
  public variantTemplateModel = new ConnectorVariantModel();
  public showPicture = false;
  public canOpenGraphicalTool = false;
  private stpConvertTaskId: string;
  public currentVariantTabId = '';
  public currentVariantTab = 0;
  public isStpVisible = false;
  public isPngVisible = false;
  public pictureData: string;
  public systemsArray: SystemModel[] = [];
  public corrosionProtectionsArray: CorosiveProtectionModel[] = [];
  public designBasesArray: DesignBaseModel[] = [];
  public choosenDesignBase: string;
  private duplicateMode = false;
  public formGroup: FormGroup;
  public variantFormGroup: FormGroup;

  ////////////////////////////////////////// temporary mocked variables
  public mockList: any[] = list;
  public mockedPictureBase64 = mockedPicture;
  public mockedStepFileBase64 = mockedStepFile;
  public variantGridData: any[] = this.mockList[0];
  public headersVariantGrid: string[] = ['Vertification', 'Method', 'Fx+', 'Fx-'];
  public displayedColumns: string[] = ['Vertification', 'Method', 'Fx+', 'Fx-'];
  public variantsList: ConnectorVariantModel[] = [];
  ///////////////////////////////////////////


  constructor(private mainPageService: MainPageService, private zone: NgZone) {}

  public ngOnInit(): void {
    this.loadData();
    this.createForm();
    this.createVariantForm();
   }

  loadData(): void {
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsArray = response;
    });
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corrosionProtectionsArray = response;
    });
    this.mainPageService.loadAllDesignBases().subscribe((response) => {
      this.designBasesArray = response;
      this.choosenDesignBase = this.designBasesArray[0]._id;
    });
   }

   loadBaseVariants() {
    this.mainPageService.loadAllConnectorVariants(this.baseData._id).subscribe((response) => {
      this.variantsList = response;
      if (this.variantsList.length > 0) {
        Object.assign(this.editedVariant, this.variantsList[this.currentVariantTab]);
      }
      if (this.variantsList.length > 0) {
        this.currentVariantTabId = this.variantsList[this.currentVariantTab]._id;
      }
    });
   }

  showBase(sender) {
    this.currentVariantTab = 0;
    this.currentVariantTabId = '';
    this.baseData = sender;
    this.editedBase = {
      ...this.baseData
    };
    this.setFilesData(sender);
    this.canOpenGraphicalTool = sender.isProtoConverted === true;
    this.loadBaseVariants();
  }

  upload(): void {
    this.readThis(this.fileInput.nativeElement.files[0]);
  }

  readThis(inputFile: any): void {
    const file: File = inputFile;
    const myReader: FileReader = new FileReader();
    const scope = this;
    myReader.onloadend = function() {
      if (file.name.includes('.stp') || file.name.includes('.step')) {
        scope.isStpVisible = true;
        scope.sendSTPFile(myReader.result, scope.baseData._id);
      } else {
        scope.zone.run(() => scope.pictureData = myReader.result);
        scope.isPngVisible = true;
        scope.sendPictureFile(myReader.result, scope.baseData._id);
      }
    };
    myReader.readAsDataURL(file);
  }

  checkIfStpIsConverted(): void {
    const self = this;
    setTimeout(() => {
      self.mainPageService.checkTaskStatus(self.stpConvertTaskId)
      .subscribe((resp) => {
        if (resp.isFinished === true) {
          self.zone.run(() => self.canOpenGraphicalTool = resp.result);
          // self.canOpenGraphicalTool = resp.result;
        } else {
          self.checkIfStpIsConverted();
        }
      });
    }, 2000);
  }
  sendSTPFile(file, id): void {
    this.canOpenGraphicalTool = false;
    this.mainPageService.sentSTPFileForConnectors(file, id)
        .subscribe((response) => {
          this.baseData.stepFile = response.fileId;
          this.stpConvertTaskId = response.id;
          console.log(response);
          this.checkIfStpIsConverted();
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
  sendPictureFile(picture, id): void {
    this.mainPageService.sendPicture(picture, id)
        .subscribe((response) => {
          this.baseData.picture = response.fileId;
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  openGraphicalTool(): void {
    this.onShowViewer.emit(new ShowViewerArgs(true, this.baseData._id, 'BASE', null));
  }

  openVariantGraphicalTool(variantId): void {
    this.onShowViewer.emit(new ShowViewerArgs(true, this.baseData._id, 'BASE', variantId));
  }

  save(): void {
    Object.assign(this.baseData, this.editedBase);
    // this.mainPageService.mysubject.next(this.baseData._id);
    
    this.mainPageService.updateUniversalConnectorInDb(JSON.stringify(this.baseData)).subscribe(() => { });
  }

  changeVariantTab(id) {
    this.currentVariantTabId = id;
    for (let i = 0; i < this.variantsList.length; i++) {
      if (this.variantsList[i]._id === this.currentVariantTabId) {
        this.currentVariantTab = i;
        Object.assign(this.editedVariant, this.variantsList[this.currentVariantTab]);
      }
    }
  }

  deletePicture() {
    this.pictureData = '';
    this.isPngVisible = false;
    this.mainPageService.deleteFile(this.baseData.picture).subscribe(() => {
    },
      () => {
      }
    );
    this.baseData.picture = null;
  }

  deleteStepFile() {
    this.isStpVisible = false;
    this.mainPageService.deleteFile(this.baseData.stepFile).subscribe(() => {
    },
      () => {
      }
    );
    this.baseData.stepFile = null;
  }

  setFilesData(connector) {
    if (connector.picture !== undefined && connector.picture !== null && connector.picture !== '') {
      this.isPngVisible = true;
      this.mainPageService.getPicture(connector.picture).subscribe((res) => {
          this.pictureData = res.src;
        },
        (error: any) => {
          console.log(error);
        }
      );
    } else {
      this.pictureData = '';
      this.isPngVisible = false;
    }

    if (connector.stepFile !== undefined && connector.stepFile !== null && connector.stepFile !== '') {
      this.isStpVisible = true;
    } else {
      this.isStpVisible = false;
    }
  }

  deleteBase() {
    this.mainPageService.removeUniversalConnector(this.baseData._id).subscribe(() => { }, () => { });
    this.mainPageService.deleteUniversalConnectorSubject.next(this.baseData._id);
  }

  saveNewVariant() {
    this.variantTemplateModel.variantId = this.baseData._id;
    this.sendVariantToDb(this.variantTemplateModel);
  }

  sendVariantToDb(variant) {
      this.mainPageService.addNewConnectorVariantIntoDb(JSON.stringify(variant))
      .subscribe((response) => {
        console.log(response);
        this.variantsList.push(response);
        if (this.variantsList.length === 1) {
          Object.assign(this.editedVariant, this.variantsList[this.currentVariantTab]);
        }
        if (this.duplicateMode) {
          this.mainPageService.duplicateVariantData(
            this.variantsList[this.currentVariantTab]._id, this.variantsList[this.variantsList.length - 1]._id).subscribe(() => {});
          this.duplicateMode = false;
        }
        this.variantTemplateModel = new ConnectorVariantModel();
        if (this.currentVariantTabId === '') {
          this.currentVariantTabId = this.variantsList[0]._id;
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  duplicateVariant() {
    this.duplicateMode = true;
    const newVariant = new ConnectorVariantModel();
    Object.assign(newVariant, this.variantsList[this.currentVariantTab]);
    newVariant.name = this.variantTemplateModel.name;
    this.sendVariantToDb(newVariant);
  }

  deleteVariant() {
    this.mainPageService.removeVariant(this.variantsList[this.currentVariantTab]._id).subscribe(() => {
      const idToDelete = this.currentVariantTabId;
      if (this.currentVariantTab === (this.variantsList.length - 1) && this.currentVariantTab !== 0) {
        this.currentVariantTab -= 1;
        this.currentVariantTabId = this.variantsList[this.currentVariantTab]._id;
      }
      else if (this.currentVariantTab === 0 && this.variantsList.length === 1) {
        this.currentVariantTabId = '';
        this.currentVariantTab = 0;
      }
      else {
        this.currentVariantTabId = this.variantsList[this.currentVariantTab + 1]._id;
      }
      this.variantsList = this.variantsList.filter(variant => variant._id !== idToDelete);
      Object.assign(this.editedVariant, this.variantsList[this.currentVariantTab]);
    }, () => { });
  }

  updateVariant() {
    Object.assign(this.variantsList[this.currentVariantTab], this.editedVariant);
    this.mainPageService.updateVariantInDb(JSON.stringify(this.variantsList[this.currentVariantTab])).subscribe(() => { });
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedBase.name, Validators.required),
      articleNumber: new FormControl(this.editedBase.articleNumber),
      description: new FormControl(this.editedBase.description),
      system: new FormControl(this.editedBase.system, Validators.required),
      corrosionProtection: new FormControl(this.editedBase.corrosionProtection),
    });
  }

  public prepareVariantCreate() {
    this.variantTemplateModel = new ConnectorVariantModel();
    this.createVariantForm();
  }

  private createVariantForm() {
    this.variantFormGroup = new FormGroup({
      name: new FormControl(this.variantTemplateModel.name, Validators.required),
      description: new FormControl(this.variantTemplateModel.description),
      system: new FormControl(this.variantTemplateModel.system, Validators.required),
      corrosionProtection: new FormControl(this.variantTemplateModel.corrosionProtection, Validators.required),
    });
  }
}
